import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductsPPLTz.css';

const ProductsPPLTz = () => {
  const navigate = useNavigate();

  // Product introduction paragraph
  const productIntroParagraphs = [
    'We serve a diverse set of markets where packaging needs to be reliable, consistent and visually strong. Our work spans categories that demand precision, durability and clean presentation, often across complex supply chains and varied retail environments. Across all segments, the focus remains on well-built structures, sharp print quality and packaging that supports brands in showing up confidently wherever they are sold.'
  ];

  // Product data with information
  const products = [
    {
      id: 1,
      image: '/images/gallery/products/fmgc_pharma.webp',
      name: 'Healthcare',
      description: 'Our healthcare packaging is designed to handle sensitive, high-stakes products with care. It emphasizes strength, clarity, and clean presentation, ensuring every carton protects its contents through transport, storage, and daily handling. Built for consistency and reliability, these structures support pharmacies and hospitals with packaging that looks professional and functions smoothly in fast-paced environments.',
      imagePosition: 'left' // image left, text right
    },
    {
      id: 2,
      image: '/images/gallery/products/personal_care.webp',
      name: 'Personal Care',
      description: 'Our personal care packaging delivers a refined appearance backed by reassuring durability. Each carton is crafted to protect delicate formulations, maintain product stability, and convey a premium feel. Clean graphics, smooth finishes, and precise structural detailing help brands communicate trust, care, and everyday quality from the very first touch.',
      imagePosition: 'right' // image right, text left
    },
    {
      id: 3,
      image: '/images/gallery/products/fmgc_food.webp',
      name: 'Food FMCG',
      description: 'Our food packaging is engineered to perform across varied climates and complex supply chains while maintaining strong shelf appeal. Each pack balances freshness protection with vibrant, consumer-friendly design. The focus remains on neat finishes, sturdy construction, and high-quality printing that enables brands to stand out in crowded retail spaces.',
      imagePosition: 'left' // image left, text right
    }
  ];

  return (
    <div className="products-ppl-tz-page">
      {/* Hero Image Section - Same as Home page */}
      <div className="hero-image-section">
        <img 
          src="/images/hero/hero-banner-products.webp" 
          alt="Hero Banner" 
          className="hero-image"
        />
      </div>

      <div className="content-container fade-in">
        <div className="products-ppl-tz-hero-wrapper">
          <div className="products-ppl-tz-header">
            <button 
              className="back-button"
              onClick={() => navigate('/')}
              aria-label="Go back to home"
            >
              ← Back to Home
            </button>
          </div>

          <div className="products-ppl-tz-hero-section">
            <div className="products-ppl-tz-title-column">
              <h1>We provide high-quality folding cartons that complement specific needs across diverse sectors</h1>
            </div>
            <div className="products-ppl-tz-intro-column">
              {productIntroParagraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>

        {/* Products Section */}
        <div className="products-grid-section">
          <h2 className="products-grid-title">Packaging for Every Need</h2>
          <div className="products-list">
            {products.map((product) => (
              <div 
                key={product.id} 
                className={`product-item product-item--${product.imagePosition}`}
              >
                <div className="product-image-container">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="product-image"
                  />
                </div>
                <div className="product-content">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsPPLTz;

